import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import userReducer from './user/index';
import siteListReducer from './siteList/index';
import widgetReducer from './widget/index';
import issuesReducer from './issues/index';
import myReportsReducer from './myReports/index';
import envReducer from './env/index';
import sitesDetailsReducer from './sitesDetails/index';
import rootSaga from './sagas';
import dashboardsReducer from './dashboards';
import raisedByWidgetDashboardReducer from './raisedByWidgetDashboard';
import automatedReportsReducer from './automatedReports/index';
import siteReducer from './site/index';
import myReportsCountReducer from './myReportsCount/index';
import paymentReducer from './payment/index';
import adminIssuesReducer from './adminIssues/index';
import siteUsersReducer from './siteUsers/index';
import issueReducer from './issue/index';
import adminSites from './adminSites';
import stopAuditReducer from './stopAudit/index';
import siteMap from './sitemap/index';
import organization from './organization/index'
import tools from './tools/index'
import dashboardCharts from './dashboardCharts/index';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const rootReducer = combineReducers({
  user: userReducer,
  siteList: siteListReducer,
  widget: widgetReducer,
  issues: issuesReducer,
  myReports: myReportsReducer,
  env: envReducer,
  siteDashboards: dashboardsReducer,
  raisedByWidgetDashboard: raisedByWidgetDashboardReducer,
  sitesDetails: sitesDetailsReducer,
  automatedReports: automatedReportsReducer,
  site: siteReducer,
  myReportsCount: myReportsCountReducer,
  payment: paymentReducer,
  adminIssues: adminIssuesReducer,
  siteUsers: siteUsersReducer,
  issue: issueReducer,
  adminSites: adminSites,
  stopAudit: stopAuditReducer,
  siteMap : siteMap,
  organization : organization,
  tools : tools,
  dashboardCharts: dashboardCharts
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: middlewares,
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
